import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full px-2 py-4 sm:px-4" }
const _hoisted_2 = { class: "flex flex-wrap items-center gap-2 mb-4 text-sm" }
const _hoisted_3 = { class: "w-full max-w-xl bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-gray-800 mb-1 px-3" }, " O que você precisa agendar? ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 mb-2 px-3" }, " Escolha o setor e a operação para ver as datas e horários disponíveis. ", -1)
const _hoisted_6 = { class: "px-3 pt-3" }
const _hoisted_7 = { class: "flex items-center justify-center gap-2" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "w-full flex flex-wrap items-center gap-x-3 gap-y-1 bg-white rounded-xl border border-gray-200 shadow-sm px-4 py-3 mb-4" }
const _hoisted_10 = { class: "text-sm text-gray-600" }
const _hoisted_11 = { class: "text-gray-800" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 hidden sm:inline" }, "|", -1)
const _hoisted_13 = { class: "text-sm text-gray-600" }
const _hoisted_14 = { class: "text-gray-800" }
const _hoisted_15 = { class: "w-full flex flex-col md:flex-row md:items-start gap-4" }
const _hoisted_16 = { class: "w-full md:w-1/3 bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-5" }
const _hoisted_17 = { class: "w-full md:flex-1 bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-5" }

import { ref, computed } from "vue";
import FormValidated from "@/components/FormValidated.vue";
import Informacoes from "@/components/agendamento/Informacoes.vue";
import CalendarioSelector from "@/components/agendamento/CalendarioSelector.vue";
import SelectInput from "@/components/inputs/SelectInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import { itensOperacao, operacaoDisponivel } from "@/components/agendamento/operacoes";
import helpers from "@/helpers";
import store from "@/store";
import router from "@/router";
import { getThemeColor } from "@/branding";
import { AgendamentoTransporteProduto } from "@/types/agendamento_transporte_produto";
import { NotaPallet } from "@/types/nota_pallet";

export interface InitialData {
  tipo_carga: string;
  placa: string;
  transportadora: string;
  veiculo: string;
  motorista: string;
  setor: string;
  celular: string;
  data: string;
  periodo: string;
  horario: string;
  operacao: string;
  observacoes: string;
  quantidade_registros: number;
  a03_ukey: string;
  tipo_produto_a_ser_descarregado: string;
  estado_produto_a_ser_descarregado: string;
  previsao_horario_chegada: string;
  peso_bruto: number | string;
  produtos: AgendamentoTransporteProduto[];
  notas: NotaPallet[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AgendamentoAgendar',
  setup(__props) {

const theme = getThemeColor();

const etapa = ref(1);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formRef = ref<any>(null);

const marcaErro = (campo: string, mensagem: string) => {
  formRef.value?.setErrors({ [campo]: mensagem });
  helpers.mensagemErro(mensagem);
};

const initialValues = ref({
  tipo_carga: "",
  placa: "",
  transportadora: "",
  veiculo: "",
  motorista: "",
  setor: "",
  celular: "",
  data: helpers.formatDate(new Date(), "yyyy-MM-dd"),
  periodo: "",
  horario: "",
  operacao: "",
  observacoes: "",
  quantidade_registros: 1,
  a03_ukey: "",
  tipo_produto_a_ser_descarregado: "",
  estado_produto_a_ser_descarregado: "",
  previsao_horario_chegada: "",
  peso_bruto: "",
  produtos: [],
  notas: [],
} as InitialData);

const usuario_externo = computed(() => store.state.acessos.usuario_externo);

const usuario_recepcao_materia_prima = computed(
  () => store.state.acessos.usuario_recepcao_materia_prima
);

const aditionalValidation = computed(() => {
  /*if (usuario_recepcao_materia_prima.value) {
    return {
      transportadora: "required",
      observacoes: "required",
    }
  }*/

  if (usuario_externo.value) {
    return {
      a03_ukey: "required",
      observacoes: "required",
    };
  }

  return {
    a03_ukey: "required",
    transportadora: "required",
    observacoes: "required",
  };
});

const validation = computed(() => ({
  tipo_carga: "required",
  transportadora: "",
  setor: "required",
  operacao: "required",
  a03_ukey: "",
  ...aditionalValidation.value,
}));

const array_setor = computed(() => {
  return store.state.arr["array_setor"]?.valores ?? [];
});

const array_setor_select = computed(() => {
  if (usuario_externo.value) {
    return array_setor.value.filter((setor) => !setor.name.includes("EXPEDIÇÃO"));
  }

  return array_setor.value;
});

const tipoPallets = (values: InitialData) =>
  values.operacao == "2" && values.tipo_produto_a_ser_descarregado == "Pallets";

const nomeSetor = (setorUkey: unknown) =>
  array_setor.value.find((i) => i.value == setorUkey)?.name ?? "";

const avancar = (values: InitialData) => {
  if (!values.setor) {
    marcaErro("setor", "Selecione o setor.");
    return;
  }

  if (!values.operacao) {
    marcaErro("operacao", "Selecione a operação (carregar ou descarregar).");
    return;
  }

  if (!operacaoDisponivel(values.setor, Number(values.operacao) as 1 | 2)) {
    marcaErro("operacao", "Este setor não possui horários para a operação selecionada.");
    return;
  }

  etapa.value = 2;
};

// Validações que dependem do setor/operação; rodam junto com as declarativas
// no submit, para TODOS os campos obrigatórios ficarem marcados de uma vez.
const validacaoExtra = (values: InitialData) => {
  const erros: Record<string, string> = {};
  const usaJanelas = !!store.state.setores_usa_janelas[values.setor];
  const nomeSetorSelecionado = array_setor.value.find(
    (i) => i.value == values.setor
  )?.name;

  if (usaJanelas && !values.horario) {
    erros.horario = "Selecione um horário disponível.";
  }

  if (!usaJanelas && !values.periodo) {
    erros.periodo = "Campo Obrigatório";
  }

  if (!usaJanelas && !values.previsao_horario_chegada) {
    erros.previsao_horario_chegada = "Campo Obrigatório";
  }

  if (
    values.operacao == "2" && // Descarregar
    nomeSetorSelecionado == "NÃO CONFORME" &&
    !values.estado_produto_a_ser_descarregado
  ) {
    erros.estado_produto_a_ser_descarregado = "Campo Obrigatório";
  }

  if (
    values.operacao == "2" && // Descarregar
    nomeSetorSelecionado == "ALMOXARIFADO" &&
    !values.tipo_produto_a_ser_descarregado
  ) {
    erros.tipo_produto_a_ser_descarregado = "Campo Obrigatório";
  }

  if (
    tipoPallets(values) &&
    store.state.notas_pallet.ativo &&
    (values.notas ?? []).length == 0
  ) {
    erros.notas = "Selecione ao menos uma nota fiscal de pallet.";
  }

  return erros;
};

const onSubmit = async (values: InitialData) => {
  if (
    values.operacao == '2' && // Descarregar
    array_setor.value.find((i) => i.value == values.setor)?.name == 'ALMOXARIFADO' &&
    (values.produtos ?? []).length === 0 &&
    values.tipo_produto_a_ser_descarregado == 'Insumos/Embalagens'
  ) {
    helpers.mensagemErro(
      'Adicione pelo menos 1 produto que será descarregado, clique no botão "Adicionar Produto".'
    );
    return;
  }

  const retorno = await store.dispatch("enviarAgendamento", values);

  if (retorno?.success) {
    /*const codigoAgendamento = retorno?.agrupamento?.numero;

    if (usuario_recepcao_materia_prima.value && !! codigoAgendamento) {
      router.push({
          path: "/meus-agendamentos",
          query: { codigo: String(codigoAgendamento) }
        });
    } else {
      router.push("/meus-agendamentos");
    }*/
    router.push("/meus-agendamentos");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FormValidated, {
      ref_key: "formRef",
      ref: formRef,
      "initial-values": initialValues.value,
      "hide-buttons": true,
      onSave: onSubmit,
      validation: _unref(validation),
      "validacao-extra": validacaoExtra
    }, {
      form: _withCtx(({ values }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(["px-3 py-1 rounded-full font-medium border", 
              etapa.value === 1
                ? `bg-${_unref(theme)}-800 border-${_unref(theme)}-800 text-white`
                : 'bg-white border-gray-300 text-gray-500'
            ])
          }, " 1. Setor e operação ", 2),
          _createVNode(_component_font_awesome_icon, {
            icon: "arrow-right",
            class: "text-gray-400"
          }),
          _createElementVNode("span", {
            class: _normalizeClass(["px-3 py-1 rounded-full font-medium border", 
              etapa.value === 2
                ? `bg-${_unref(theme)}-800 border-${_unref(theme)}-800 text-white`
                : 'bg-white border-gray-300 text-gray-500'
            ])
          }, " 2. Dados e horário ", 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createVNode(SelectInput, {
            name: "setor",
            tclass: "w-full",
            label: "Setor",
            items: _unref(array_setor_select)
          }, null, 8, ["items"]),
          _createVNode(RadioGroup, {
            name: "operacao",
            label: "Operação",
            tclass: "w-full",
            items: _unref(itensOperacao)(values.setor)
          }, null, 8, ["items"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_t_button, {
              type: "button",
              class: _normalizeClass(["w-full py-3 text-lg text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-4", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900 focus:ring-${_unref(theme)}-300`]),
              onClick: ($event: any) => (avancar(values))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, [
                  _createTextVNode(" Continuar "),
                  _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
                ])
              ]),
              _: 2
            }, 1032, ["class", "onClick"])
          ])
        ], 512), [
          [_vShow, etapa.value === 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createTextVNode(" Setor: "),
              _createElementVNode("b", _hoisted_11, _toDisplayString(nomeSetor(values.setor)), 1)
            ]),
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode(" Operação: "),
              _createElementVNode("b", _hoisted_14, _toDisplayString(values.operacao == 1 ? "Carregar" : "Descarregar"), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["ml-auto text-sm font-semibold underline hover:opacity-80 transition-opacity duration-150 focus:outline-none", `text-${_unref(theme)}-800`]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (etapa.value = 1))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "pen",
                class: "mr-1"
              }),
              _createTextVNode("Alterar ")
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(Informacoes)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(CalendarioSelector)
            ])
          ])
        ], 512), [
          [_vShow, etapa.value === 2]
        ])
      ]),
      _: 1
    }, 8, ["initial-values", "validation"])
  ]))
}
}

})